/**
 * This file contains the application's colors.
 *
 * Define color here instead of duplicating them throughout the components.
 * That allows to change them more easily later on.
 */

const Colors = {
  //common
  text: '#000000',
  primary: '#27a3ac',
  defaultPrimary: '#27a3ac',
  primaryLight: '#CEDADB',
  success: '#28a745',
  error: '#dc3545',
  white: '#FFFFFF',
  black: '#000000',
  red: '#FF0000',
  shadow: '#00287A',
  grey: '#e9e9e9',
  whiteSmoke: '#F5F5F5',
  BoxShadow: '#00000040',
  linkColor: '#0645AD',
  vivid: '#C92424',
  gray: '#808080',

  //ChargePointLogListItem
  ChargePointLogListItemBoxShadow: '#00000040',
  ChargePointLogListItemCodeSnippet: '#f4f4f4',
  ChargePointLogListItemHover: '#f3f9fb',
  ChargePointLogListItemCopy: '#171717',
  ChargePointLogListItemCopyHover: '#e1e1e1',

  //IFModal
  backdrop: '#000000',
  exitIcon: '#000000',

  // Side Navigation Bar
  LogoBackground: '#3dacb4',
  NavigationBarBackground: '#27a3ac',
  IconHover: '#52b5bd',
  ToolTipNavBar: '#333',

  // StationListHeader
  StationListHeaderBackground: '#F0F8FA',

  // StationListItem
  StationListItemBackgroundHover: '#F0F8FA',
  StationListItemSelected: '#E4F3F7',

  AvailableConnector: '#1F8B24', //Green
  PreparingConnector: '#d3d300', //Yellow
  SuspendedConnector: '#d3d300', //Yellow
  OccupiedConnector: '#1672EC', //Blue - coarse in-use status post status-model inversion
  ReservedConnector: '#d3d300', //Yellow
  ChargingConnector: '#1672EC', //Blue
  FinishingConnector: '#1672EC', //Blue
  UnAvailableConnector: '#FF0000', //Red
  FaultedConnector: '#FF0000', // Red
  OfflineConnector: '#818181', //Grey
  TransparentBackground: '#ffffff00',
  LastUpdatedColor: '#00000080',

  FilterBackground: '#e8f6f7',
  deadButton: 'gray',
  transparent: 'transparent',

  // IFRangePicker
  IFRangePickerShadow: '#0000001a',
  IFRangePickerButton: '#3597ff',

  // Filter
  FilterShadow: '#0000002f',
  FilterClearButton: '#E1E1E1ff',
  FilterIconEmpty: '#808080',
  FilterIconFilled: '#000000',
  ChargingTransactionListItemShadow: '#0000001a',

  //tooltip
  tooltipGrey: '#808080',

  //ConfigurationListItem
  ConfigurationListItemBackground: '#e1ffff1a',
  ConfigurationListItemBoxShadow: '#00000080',

  //ChargePointLogTransaction
  ChargePointLogTransactionItemBoxShadow: '#00000040',
  ChargePointLogTransactionItemBackground: '#e1ffff1a',

  //UserTransactionListItem
  UserTransactionItemBackground: '#e1ffff1a',

  // ChargePointTab
  LowOpacityText: '#00000033',

  // ChargePointTabs
  TabsBackground: '#27A3AC1A',

  // Connector List Item
  MaxPowerBackground: '#C4C4C480',
  GreyBackground: '#F4F4F4',
  StatusYellowText: '#b3c117',
  BoxShadowColor: '#00000040',

  // Upload Drop Zone
  DropZoneBackground: '#e1e1e1',

  // Upload Diagnostics Modal
  CurrentFirmwareText: '#000000',
  UploadModalUpdateText: '#000000',

  //login
  loginBackgroundColor: '#ffffff',
  loginBackgroundShadow: '#00000040',

  // ChargePointDetails
  DividerColor: '#0000001a',
  tooltipGreyBackground: '#0000004D',
  tooltipBoxShadow: ' #00000040',
  tooltipText: '#00000066',

  // ChargePointDetailsTabs
  NotSelectedText: '#0000004D',

  //Reset password
  resetPasswordBackgroundColor: '#fffffff2',
  resetPasswordBackgroundShadow: '#00000040',
  resetPasswordModalSubTitle: '#000000',
  pinFieldBackground: '#f8f9fa',
  pinFieldBorder: '#cccccc',
  pinFieldInvalidBorder: '#dc3545',
  pinFieldInvalidBoxShadow: '#dc354580',
  //
  background: '#F6F6F6',
  SideBarItemHover: '#ffffff80',

  // Empty States
  emptyStatesSubTitle: '#818181',

  // Skeleton
  skeleton: '#e3e3e3',
  SkeletonColor: '#0000001c',

  //Operator User List Item
  OperatorUserListItemEmail: '#00000099',
  OperatorUserListPenIcon: '#818181',
  OperatorUserListDeleteIcon: '#ff0000',

  //Operator User List
  OperatorUserListDeleteModalCancel: '#27a3ac',
  OperatorUserListDeleteModalDelete: '#FF0000',

  // Create Account
  CreateAccountBackgroundColor: '#fffffff2',
  CreateAccountBackgroundShadow: '#00000040',

  //IFToastMessage
  ToastInfo: '#2196f3',
  ToastSuccess: '#4caf50',
  ToastError: '#f44336',
  ToastWarning: '#ffb300',

  // CardListItem
  ActiveCard: '#1F8B24',
  InactiveCard: '#FF0000',
  DeActivatedCard: '#818181',
  CardListItemShadow: '#0000001a',
  ClipboardCopy: '#808080',

  TransactionDownload: '#808080',

  HexTransparent: {
    T100: 'FF',
    T95: 'F2',
    T90: 'E6',
    T85: 'D9',
    T80: 'CC',
    T75: 'BF',
    T70: 'B3',
    T65: 'A6',
    T60: '99',
    T55: '8C',
    T50: '80',
    T45: '73',
    T40: '66',
    T35: '59',
    T30: '4D',
    T25: '40',
    T20: '33',
    T15: '26',
    T10: '1A',
    T5: '0D',
    T0: '00',
  },

  //Stations Map
  MapViewToggleSelected: '#000000',
  MapViewToggleNotSelected: '#0000004d',
  MapViewToggleBackground: '#FFFFFF',
  ConnectorComponentBorder: '#c4c4c480',
  ChargerSpeedContainerBackground: '#c4c4c480',
  ChargePointNameText: '#000000',
  ClusterCountText: '#FFFFFF',
  StationMapComponentBackground: '#FFFFFF',
  StationHeaderBackground: '#FFFFFF',
  StationHeaderText: '#000000',
  StationBodyBackground: '#FFFFFF',

  // tooltip
  DeadTooltip: '#A9A9A9',

  // Spinner
  SpinnerSecondaryColor: '#FFFFFF4D',

  ToggleDisabled: '#c5c6c7',

  // File color
  FileColor: '#8b949e',
  // ChargePoint Privacy Picker
  PrivacyPickerPublic: '#1F8B24B2',
  PrivacyPickerPrivate: '#FF0000B2',

  ChargePointTariffListItem: {
    RemoveIcon: '#FF0000',
    AddIcon: '#1F8B24',
    gray: '#0000004d',
    black: '#000000',
    defaultSub: '#22BADB',
  },

  ChargePointScheduleListItem: {
    RemoveIcon: '#FF0000',
    AddIcon: '#1F8B24',
    gray: '#0000004d',
    black: '#000000',
  },

  // Add button
  ChargePointSpecsAdd: '#1F8B24',
  ChargePointSpecsGreyedOut: '#0000004D',
  ChargePointSpecsEdit: {
    ListBoxShadow: '#00000040',
  },

  // ChargePoint Specs Container
  ChargePointSpecsTabsNotSelected: '#0000004D',
  ChargePointSpecsListContainerShadow: '#00000040',

  // UsersPage
  UserGroupsContainer: '#00000040',

  //
  ChargingTokenListItemBackgroundHover: '#F0F8FA',
  ChargingTokenListItemSelected: '#E4F3F7',
  ChargingTokenListItemUid: '#00000080',
  AvailableChargingToken: '#1F8B24', //Green
  InactiveChargingToken: '#FF0000', //Red
  DeactivatedChargingToken: '#818181', //Grey
  TransparentBackground: '#ffffff00',
  StatusContainerBackground: '#C4C4C433',
  ChargingtokenStatus: {
    Active: '#1F8B24B2',
    Inactive: '#FF0000B2',
    Deactivated: '#818181',
  },

  // Station Uptime Monitor
  StationUptimeStatus: {
    Online: '#1f8b24',
    Offline: '#b3b3b3',
    Unstable: '#ff4500',
  },

  // Connectors Utilization
  ConnectorStatus: {
    AVAILABLE: '#1F8B24',
    CHARGING: '#1672EC',
    OCCUPIED: '#d3d300',
    UNAVAILABLE: '#818181',
    FAULTED: '#FF0000',
    SuspendedEVSE: '#FF6E00',
    FINISHING: '#775DD0',
    Empty: ' #eeeeee',
    PREPARING: '#d3d300',
  },

  MapSearchBoxDivider: '#a9a9a9',
  MapSearchBoxIcons: '#5A5A5A',
  MapSearchLightGray: '#adadad',

  TransactionStatus: {
    Void: '#808080',
    Corrected: '#008000',
    Normal: '##00000000',
    Reversed: '#FF0000',
  },

  AlertUnstableText: '#d3d300',
  AlertFaultedText: '#FF0000',
  AlertOfflineText: '#818181',
  AlertOfflineBackground: '#F4F4F4',

  AlertItem: {
    AddIcon: '#1F8B24',
    GreyedOut: '#0000004D',
    Hover: '#f3f9fb',
    SettingsTitle: '#aaaaaa',
  },

  ScheduleChartTick: '#e0e0e0',
  ForgotPassword: '#1672EC',
  TooltipArrow: '#333',

  ActionDotBackground: '#d0f0f0',
  ActionLine: '#bdbdbd',
  DetailPanel: '#818181',
  Accordion: '#fafafa',

  LogsBackGroundIndicator: '#f8f8f8',
  LogsBackGroundIndicatorHover: '#f5f5f5',

  Analytics: {
    Icons: '#575757',
    LightGreen: '#CCE6CC',
    LightRed: '#FFCCCC',
    GreenPercentage: '#1F8B24',
    AnalyticsDivider: '#E6E6E6',
    IconBackground: '#F3F3F3',
    AnalyticsDataCard: '#F7F8FB',
    AnalyticsDataGreyText: '#575757',
    GraphGradient: '#D8EFF0',
    Available: '#4B9D49',
    Occupied: '#D3D300',
    Charging: '#1772EC',
    Unavailable: '#818181',
    Faulted: '#FF0000',
    Offline: '#B3B3B3',
    PeakHour: {
      Shade1: '#0C3E42',
      Shade2: '#135D63',
      Shade3: '#1B7C84',
      Shade4: '#27A3AC',
      Shade5: '#66CCD2',
      Shade6: '#9ADDE1',
      Shade7: '#D1EFF1',
      PeakHourBackground: '#F7FCFC',
      PeakHourBorder: '#E0E0E0',
    },

    RadialBar: {
      LastYear: '#a6e6eb',
      ThisYear: '#6bd6dd',
      Last6Months: '#2fc5d0',
      Last3Months: '#228d94',
      LastMonth: '#145459',
      LastWeek: '#0e3b3e',
    },
  },
}

export default Colors
